// import React from 'react'
// import styled from 'styled-components'
// import { StyledWrapper } from './styles';

// const ContentSec3 = ({props}:any) => {
//     console.log(props);
//   return (
//           <StyledWrapper>
//             {
//               props?.description &&
//               <div className='w-[98%] xl:w-[95%] py-10 lg:py-20 px-4 text-[20px] leading-10  contentsection1 bg-white 2xl:w-[76%] mx-auto'
//                 dangerouslySetInnerHTML={{ __html: props?.description }} />
//             }
//           </StyledWrapper>
//   )
// }

// export default ContentSec3


"use client";
import { useMemo } from "react";
import { LuExternalLink } from "react-icons/lu";
import { FaTrophy, FaLightbulb, FaChartLine, FaUsers, FaBriefcase,  FaHeart } from "react-icons/fa6";
import Button from '@/components/CommonComponent/button';
import { FaFileAlt, FaFolderOpen, FaQuestionCircle } from "react-icons/fa";

interface ContentData {
  description: string;
}

const ContentSection = ({ props }: { props: ContentData }) => {

  const parseContent = (html: string) => {
    if (typeof window === "undefined") return { drives: [], experience: [] };

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const drives = Array.from(doc.querySelectorAll("h4 + ul li")).map(li => ({
      text: li.textContent?.replace(/(Innovation & Creativity|Data-Driven Strategies|Collaboration & Growth):/, '').trim() || "",
      icon: li.textContent?.includes("Innovation") ? "innovation" : 
            li.textContent?.includes("Data") ? "data" : 
            "collaboration"
    }));

    const experience = Array.from(doc.querySelectorAll("h3 + ul li")).map(li => {
      const link = li.querySelector("a");
      return {
        text: li.textContent?.replace(link?.textContent || "", "").replace(":", "").trim() || "",
        linkText: link?.textContent || "",
        url: link?.getAttribute("href") || "#",
        icon: li.textContent?.includes("Life at") ? "life" : 
              li.textContent?.includes("Awards") ? "awards" : 
              li.textContent?.includes("Career") ? "career" : 
              li.textContent?.includes("Portfolio") ? "portfolio" : 
              li.textContent?.includes("Case") ? "case" : "about"
      };
    });

    return { drives, experience };
  };

  const content = useMemo(() => parseContent(props.description), [props.description]);

  const getIcon = (type: string) => {
    switch(type) {
      case 'innovation': return <FaLightbulb className="text-" />;
      case 'data': return <FaChartLine className="text-blue-500" />;
      case 'collaboration': return <FaUsers className="text-" />;
      case 'life': return <FaHeart className="text-purple-500" />; 
      case 'awards': return <FaTrophy className="text-blue-600" />;
      case 'career': return <FaBriefcase className="text-black" />;
      case 'portfolio': return <FaFolderOpen className="text-blue-600" />;
      case 'case': return <FaFileAlt className="text-blue-600" />;
      default: return <FaQuestionCircle className="text-blue-500" />;
    }
  };

  return (
    <div className="w-full max-w-[76rem] mx-auto px-4 py-12">
      <div className="mb-16">
        <h2 className="text-3xl font-bold mb-8 text-center text-gray-800">What Drives Us</h2>
        
        {/* Mobile View */}
        <div className="md:hidden space-y-4">
          {content.drives.map((item, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-md flex items-start gap-4 transition-shadow hover:shadow-lg"
            >
              <div className="text-2xl mt-1">
                {getIcon(item.icon)}
              </div>
              <div>
              <h4 className="text-xl font-semibold mb-3 text-[#1090D0]">
                {item.icon === 'innovation' ? 'Innovation & Creativity' : 
                 item.icon === 'data' ? 'Data-Driven Strategies' : 'Collaboration & Growth'}
              </h4>
                <p className="text-gray-800">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
        
        {/* Desktop View */}
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-6">
          {content.drives.map((item, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-all flex flex-col items-center text-center"
            >
              <div className="text-4xl mb-4">
                {getIcon(item.icon)}
              </div>
              <h4 className="text-xl font-bold mb-3 text-[#1090D0]">
                {item.icon === 'innovation' ? 'Innovation & Creativity' : 
                 item.icon === 'data' ? 'Data-Driven Strategies' : 'Collaboration & Growth'}
              </h4>
              <p className="text-gray-700">{item.text}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mb-16">
        <h2 className="text-3xl font-bold mb-8 text-center text-gray-800">Explore More About the W3era Experience</h2>
        
        {/* Mobile View */}
        <div className="md:hidden space-y-4">
          {content.experience.map((item, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-md transition-shadow hover:shadow-lg"
            >
              <div className="flex items-start gap-4">
                <div className="text-2xl mt-1">
                  {getIcon(item.icon)}
                </div>
                <div>
                <h4 className="text-xl font-semibold mb-2 text-gray-800">
                    {item.icon === 'life' ? 'Life at W3era' : 
                     item.icon === 'awards' ? 'Our Awards' : 
                     item.icon === 'career' ? 'Careers' : 
                     item.icon === 'portfolio' ? 'Our Portfolio' : 
                     item.icon === 'case' ? 'Case Studies' : 'About Us'}
                  </h4>
                  <p className="text-gray-800 mb-2">{item.text}</p>
                  <a 
                    href={item.url} 
                    className="text-[#1090D0] font-medium flex items-center gap-1 hover:underline"
                  >
                    {item.linkText} <LuExternalLink size={14} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Desktop View */}
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-2 gap-6">
          {content.experience.map((item, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-all"
            >
              <div className="flex items-start gap-6">
                <div className="text-3xl mt-1">
                  {getIcon(item.icon)}
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-2 text-gray-800">
                    {item.icon === 'life' ? 'Life at W3era' : 
                     item.icon === 'awards' ? 'Our Awards' : 
                     item.icon === 'career' ? 'Careers' : 
                     item.icon === 'portfolio' ? 'Our Portfolio' : 
                     item.icon === 'case' ? 'Case Studies' : 'About Us'}
                  </h4>
                  <p className="text-gray-600 mb-4">{item.text}</p>
                  <a 
                    href={item.url} 
                    className="text-[#1090D0] font-medium flex items-center gap-2 hover:underline"
                  >
                    {item.linkText} <LuExternalLink size={14} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      
      <div className="mt-16 text-center">
        <h3 className="text-2xl md:text-3xl font-bold mb-6 text-gray-800">
          Want to work with the best in the industry?
        </h3>
        <a
          href="https://www.w3era.com/career/"
          className="inline-block"
        >
           <Button content="Join the W3era Team" />
        </a>
      </div>
    </div>
  );
};

export default ContentSection;